export default "__VITE_ASSET__Gg67fU$T__"